import React, {useState, useContext, useEffect} from "react";
import { useCallback } from "react";
import { reqAllBooks } from "./api";
const AppContext = React.createContext();

const AppProvider = ({children}) => {
    const [searchTerm, setSearchTerm] = useState("the lost world");
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [resultTitle, setResultTitle] = useState("");

    const getBooksData = useCallback(async() =>{
        setLoading(true);
        console.log(searchTerm);
        const result = await reqAllBooks(searchTerm);
        console.log(result);
        
        const {docs} = result;

        if(docs){
            const newBooks = docs.slice(0, 20).map((bookSingle) => {
                const {
                    key,
                    author_name,
                    cover_i,
                    edition_count,
                    first_publish_year,
                    title
                } = bookSingle

                return {
                    id: key,
                    author: author_name,
                    cover_id: cover_i,
                    edition_count: edition_count,
                    first_publish_year: first_publish_year,
                    title: title,
                }
            });
            console.log(newBooks);
            setBooks(newBooks);

            if(newBooks.length > 1) {
                setResultTitle("your Search Result");
            } else {
                setResultTitle("No Search Result Found!");
            }
        } else {
            setBooks([]);
            setResultTitle("No search Result Found!");
        }
        setLoading(false);
    },[searchTerm]);

    useEffect(() => {
        getBooksData();
    },[searchTerm,getBooksData]);

    return (
        <AppContext.Provider value={{
            loading, books, setSearchTerm, resultTitle, setResultTitle
        }}>
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext);
}

export {AppContext,AppProvider};